<template>
  <div class="inside_wrapper">
    <el-divider content-position="left">录取查询</el-divider>
    <el-empty v-if="!searchInfo" description="暂无录取信息，请完成资料、确认专业、缴费后稍等在查询"></el-empty>
    <div v-else class="search_wrapper">
      <div class="search_state">
        <span v-if="searchInfo.IsAdmission">
          <i class="el-icon-success"></i> 恭喜你! {{searchInfo.StudentName}}同学，你以优异的成绩被录取成功了！
        </span>
        <span v-else>
          <i class="el-icon-error"></i> 很遗憾！，{{searchInfo.StudentName}}同学，你没有被录取，请再接再厉！
        </span>
      </div>
        <div class="search_top">
          以下是你的录取信息:
        </div>
      <div class="search_info">

        <div class="search_item">
          <div class="search_title">姓名：</div>
          <div class="search_con">{{searchInfo.StudentName}}</div>
        </div>
        <div class="search_item"  v-if="searchInfo.IsAdmission">
          <div class="search_title">录取专业：</div>
          <div class="search_con">{{searchInfo.MajorName}}</div>
        </div>
        <div class="search_item">
          <div class="search_title" >报考专业：</div>
          <div class="search_con">{{searchInfo.SignMajorName}}</div>
        </div>
        <div class="search_item"  v-if="!searchInfo.IsAdmission">
          <div class="search_title">数学成绩：</div>
          <div class="search_con">{{searchInfo.Mathematics}}</div>
        </div>
        <div class="search_item"  v-if="!searchInfo.IsAdmission">
          <div class="search_title">语文成绩：</div>
          <div class="search_con">{{searchInfo.Chinese}}</div>
        </div>
          <div class="search_item" v-if="!searchInfo.IsAdmission">
          <div class="search_title">英语成绩：</div>
          <div class="search_con">{{searchInfo.English}}</div>
        </div>
                  <div class="search_item" v-if="!searchInfo.IsAdmission">
          <div class="search_title">面试成绩：</div>
          <div class="search_con">{{searchInfo.Interview}}</div>
        </div>
        <div class="search_item">
          <div class="search_title">成绩总分：</div>
          <div class="search_con">{{searchInfo.Mathematics+searchInfo.Chinese+searchInfo.English+searchInfo.Interview}}</div>
        </div>
                <!-- <div class="search_item">
          <div class="search_title">录取分数：</div>
          <div class="search_con"  style="color:red">{{searchInfo.Score}}</div>
        </div> -->
        <div class="search_item">
          <div class="search_title">备注：</div>
          <div class="search_con"  v-if="score.ExpressNumber">
            你的录取通知书已送出！快递单号是：{{searchInfo.ExpressNumber}}
          </div>
        </div>
      </div>
      <div class="text-notice">
        <p>
          1.学校在4月7日-4月11日内会公示预录取相关信息，公示期5天，拟录取考生须经公示无异议后才能录取。如有疑问，请拨打电话0817-2603636咨询。
        </p>
        <p>
          2.预录取考生若要放弃本次预录取资格，考生本人在公示期5天内持准考证、身份证以及考生及家长签字的《放弃录取申请》原件到学校招生就业处办理相关手续。
        </p>
        
      </div>
            <div class="table-list">
        <el-collapse>
          <el-collapse-item title="点击查看公示名单">
            <el-table v-if="tableData"
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                prop="Number"
                label="考生号"
                width="180">
              </el-table-column>
              <el-table-column
                prop="Name"
                label="姓名"
                width="180">
              </el-table-column>
              <el-table-column
                prop="CardNumber"
                label="身份证号">
              </el-table-column>
              <el-table-column
                prop="MajorName"
                label="录取专业">
              </el-table-column>
              <el-table-column
                prop="Type"
                label="录取类别">
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent ,reactive } from "vue";
import useWrapper from "./useSearch"
import {useStore} from "vuex"
import { scopePublishApi } from "@/api/common";
// import { useRoute } from "vue-router";
export default defineComponent({
  name: "",
  components: {},
  setup() {
    //*********** definning variables start **********//
    const {rawData,scopeSearch} = useWrapper()
    const store = useStore()
    let userInfoStr = localStorage.getItem('userInfo')
    let tableData = reactive({
      tableData:[]
    })
    getScopePublish()
    //*********** definning variables end **********//
    //*********** initData start **********//
    if(userInfoStr){
      let userInfo = JSON.parse(userInfoStr)
      if(userInfo.IsSure){
        scopeSearch(userInfo.Id)
      }
    }

    //*********** initData end **********//
    function getScopePublish(){
      scopePublishApi({Keywords:'',PageIndex:1,PageSize:3000}).then(res=>{
        tableData.tableData = res.contents
      })
    }
    //*********** format start **********//
    //*********** format end **********//
    //*********** Data FUN start **********//
    //*********** Data FUN end **********//
    //*********** DOM FUN start **********//
    //*********** DOM FUN end **********//
    return {
      ...toRefs(rawData),...toRefs(tableData)
    }
  },
});
</script>
<style lang="scss">
  .search_state{ 
    text-align: center; color: #666; font-weight: bold; font-size: 20px;margin-top: 40px;
    .el-icon-success{color: #67C23A;}
    .el-icon-error{color: #F56C6C;}
  }
  .search_top{ width: 600px; margin:0 auto; padding: 20px 0; color: #666;}
  .search_info {
  border: 1px solid #f1f1f1;
  width: 600px; font-size: 14px;
  border-bottom: none; margin:0 auto;

  .search_item {
    border-bottom: 1px solid #f1f1f1;
    line-height: 3;
    display: flex;
    font-size: 14px;
    .search_title {
      flex: 0 0 100px;
      padding: 0 10px;
      text-align: right;
      border-right: 1px solid #f1f1f1;
      color: #333;
    }
    .search_con {
      padding: 0 10px;
      color: #666;
    }
  }
}
.text-notice{width: 80%; margin: 30px auto;}
.text-notice p{text-indent: 2em; font-size: 16px; color: #666; line-height: 2; }
  // .search_info{color: #666; font-size: 16px; line-height: 2; text-align: center; margin-top: 30px;}
</style>
